import { useEffect, useRef } from 'react'
import {
  // startDatadogBrowserLogs,
  startDatadogBrowserRum,
} from 'src/configs/datadog'
import { env } from 'src/configs/env'

export default function DatadogBrowserRum() {
  const isFirstRender = useRef(true)

  useEffect(() => {
    if (env.datadog.env === 'b2c-prod') {
      if (isFirstRender.current) {
        isFirstRender.current = false
        startDatadogBrowserRum()
        //TODO:  startDatadogBrowserLogs()
      }
    }
  }, [])

  return null
}
